import { render, staticRenderFns } from "./select-owner-modal.vue?vue&type=template&id=99e1ef64&scoped=true&"
import script from "./select-owner-modal.vue?vue&type=script&lang=js&"
export * from "./select-owner-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e1ef64",
  null
  
)

export default component.exports